import type { GameConfig } from '@hollowveil/shared';
import { reveilQuests } from './quests';
import { reveilRooms } from './rooms';

/**
 * Configuration pour l'aventure "Le (R)éveil de l'Éducatrice"
 *
 * Synopsis: Côtelette, une éducatrice spécialisée ordinaire, est choisie par
 * l'Oracle Chevelu pour aider des âmes en détresse à travers 5 mondes.
 * Elle commence comme novice et DEVIENT "La Grande Éducatrice" à la fin.
 *
 * Twist final: L'Oracle Chevelu est en réalité Benours déguisé avec une
 * magnifique perruque, qui a créé tout ça pour elle.
 */
export const reveilEducatriceConfig: GameConfig = {
  title: 'Le (R)éveil de l\'Éducatrice',
  version: '1.0.0',
  startingRoomId: 'room_sanctuary',
  character: {
    id: 'cotelette',
    name: 'Côtelette',
    modelId: 'character_cotelette', // À créer - brune, yeux verts, cheveux bouclés mi-longs
    animations: {
      idle: 'idle',
      walk: 'walk',
      interact: 'interact',
    },
    moveSpeed: 4,
  },
  rooms: reveilRooms,
  quests: reveilQuests,
};

// Export pour être utilisé dans le sélecteur d'aventure
export default reveilEducatriceConfig;
